import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {Carousel} from 'react-responsive-carousel';
import coverImg from '../../../../assets/img/revamp/coverImg01.png'
import coverImg2 from '../../../../assets/img/institute/Banner Desktop.png'
import whyUs from '../../../../assets/img/revamp/whyUs01.png'
import './version04.scss'
import {Row, Col, Container} from "reactstrap";
import webConfig from '../../../../config/WebConfig'
import {Icon} from '@iconify/react';
import TeacherTile from "../../../../components/TeacherTile/App";
import TimetableView from "../../../../components/Timetable/Timetable";
import VideoPlayerView from "../../../../components/YoutubePlayerViwe/VideoPlayerView";
import HowItsWork from "../../../../components/HowItsWork/HowItsWork";
import InquiryForm from "../../../../components/InquiryForm/InquiryForm";
import * as commonFunc from '../../../../utils/commonFunc'
import FAQ from "../../../../components/FAQ/FAQ";
import * as instituteService from '../../../../services/institute'
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import * as actionInstituteCreator from "../../../../store/domain/institute/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import HomeView from "./homeView/HomeView";
import * as constants from "../../../../const/constants";
import * as actionClassCreator from "../../../../store/domain/classes/action";
import * as actionLectureCreator from "../../../../store/domain/lecturer/action";
import CourseSlides from "../../../../components/CourseSlides/CourseSlides";

class LandingLayout04 extends React.Component {

    state = {
        teacher: [],
        teacherDetails: [],
        screenSize: window.innerWidth,
        classes: [],
    };

    async componentDidMount() {

        this.setState({screenSize: window.innerWidth});
        if (webConfig.LMSStatus === "LMS") {
            await this.fetchInstituteTeachers();
            this.fetchClassesFromHome();
        } else {
            this.props.fetchTeachers(webConfig.teachersDetails[0]);
        }

    }

    fetchClassesFromHome = async () => {

        this.props.spinnerHandler({isSpin: true, type: 15});
        await instituteService.getTeacherDetails(1)
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    let body = response.body;
                    let data = [{
                        classes: body.classes,
                        teacherId: body.id,
                        teacherName: body.name
                    }];
                    this.props.fetchLecture({
                        name: body.name,
                        about: body.description,
                        image: body.imageUrl,
                        defaultImage: '',
                        qualification: body.qualification,
                        coverImage: body.coverImage,
                        privileges: body.privileges
                    });
                    this.props.fetchLectures(data);
                    this.setState({
                        lessons: body.lessons,
                        classes: body.classes,
                        privileges: body.privileges.split(':')[1],
                        teacherDetails: {
                            name: body.name,
                            about: body.description,
                            image: body.imageUrl,
                            defaultImage: '',
                            qualification: body.qualification,
                            description: body.description,
                            coverImage: body.coverImage,
                            privileges: body.privileges
                        }
                    })
                } else {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })

    };

    fetchInstituteTeachers = async () => {
        this.props.spinnerHandler({isSpin: true, type: 15});
        await instituteService.getInstituteTeachers()
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    this.props.fetchTeachers(response.body.teachers);
                    this.setState({teachers: response.body.teachers})
                } else {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    };

    render() {
        //single teacher version 01
        let {teachers, lmsStatus} = this.props;
        let {screenSize, classes, teacherDetails} = this.state;

        return (
            teachers?.length !== 0 && <div className={'version01'}>
                <main>

                    <section>
                        <HomeView/>

                        <div id={'aboutUsSection'} className=" container pt-3 pb-6">
                            {screenSize > 768 ?
                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                      { webConfig.LMSStatus === 'NOT_LMS' ? <img className='whyUs-img ' src={webConfig.teachersDetails[0].imageUrl}
                                             alt=""/>:<img className='whyUs-img ' src={teacherDetails.image}
                                                           alt=""/>
                                      }
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6}>
                                        <div className='whyUs-content-wrapper'>
                                            <h1>Why Us</h1>
                                            <p>{webConfig.whyUsPara}
                                            </p>
                                            <div className='mt-3'>
                                                <h5 style={{color: 'black'}}>Follow us on social media</h5>
                                                <div className='justify-content-start'>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          height='30px' icon="bxl:facebook"/>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          className='mx-3' height='30px'
                                                          icon="akar-icons:twitter-fill"/>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          className='mx-3' height='30px'
                                                          icon="akar-icons:youtube-fill"/>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          className='mx-3' height='30px'
                                                          icon="akar-icons:whatsapp-fill"/>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row> :
                                <Row>

                                    <Col xs={12} sm={12} md={12} lg={6}>
                                        <div className='whyUs-content-wrapper'>
                                            <h1>Why Us</h1>
                                            <p>{webConfig.whyUsPara}
                                            </p>
                                            <div className='my-3'>
                                                <h5 style={{color: 'black'}}>Follow us on social media</h5>
                                                <div className='justify-content-start'>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          height='30px' icon="bxl:facebook"/>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          className='mx-3' height='30px'
                                                          icon="akar-icons:twitter-fill"/>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          className='mx-3' height='30px'
                                                          icon="akar-icons:youtube-fill"/>
                                                    <Icon style={{color: `${webConfig.secondaryColor}`}}
                                                          className='mx-3' height='30px'
                                                          icon="akar-icons:whatsapp-fill"/>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col xs={12} sm={12} md={12} lg={6}>
                                        { webConfig.LMSStatus === 'NOT_LMS' ? <img className='whyUs-img ' src={webConfig.teachersDetails[0].imageUrl}
                                                                                   alt=""/>:<img className='whyUs-img ' src={teacherDetails.image}
                                                                                                 alt=""/>
                                        }
                                    </Col>

                                </Row>
                            }
                        </div>
                        {/*webConfig.teachersDetails[0].name*/}

                        <div id='teachersSection' className="container teachers-wrapper pt-3 pb-6">
                            {
                                webConfig.LMSStatus === 'NOT_LMS' && webConfig.teachersDetails[0]?.classes?.length !== 0 ?
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <div className="teacher-topic-holder">
                                                <h1 className={'main-topic'}>
                                                    {webConfig.teachersDetails[0].name}'s Classes
                                                </h1>
                                                <p className={' py-4'}>{teachers.description}</p>
                                            </div>
                                        </Col>
                                    </Row> : webConfig.LMSStatus === 'LMS' && teacherDetails && classes?.length !== 0 ?
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <div className="teacher-topic-holder">
                                                <h1 className={'main-topic'}>
                                                    {teacherDetails.name}'s Classes
                                                </h1>
                                                <p className={' py-4'}>{teacherDetails.description}</p>
                                            </div>
                                        </Col>
                                    </Row> : null
                            }

                            {
                                webConfig.LMSStatus === 'NOT_LMS' && webConfig.teachersDetails[0]?.classes?.length !== 0 ?
                                    <section className=" class-section">
                                        <Container>
                                            <CourseSlides classesByLecture={webConfig.teachersDetails[0].classes}
                                                          privileges={this.state.privileges}/>
                                        </Container>
                                    </section> :

                                    webConfig.LMSStatus === 'LMS' && classes?.length !== 0 ?
                                        <section className=" class-section">
                                            <Container>
                                                <CourseSlides classesByLecture={classes}
                                                              privileges={this.state.privileges}/>
                                            </Container>
                                        </section> : null
                            }


                        </div>

                        <TimetableView/>
                        {/*<VideoPlayerView version={webConfig.layout} youtubeLikes={webConfig.youtubeRefVideoLink}/>*/}
                        <HowItsWork desc={webConfig.howItsWorkPara}/>
                        <InquiryForm desc={webConfig.inquiryPara}/>
                        <FAQ desc={webConfig.FAQDesc} faq={webConfig.faq}/>

                    </section>
                </main>
            </div>
        )

    }
}


const mapStateToProps = (state) => ({
    institute: state.institute.institute,
    teachers: state.institute.teachers,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchTeachers: data => dispatch(actionInstituteCreator.fetchTeachers(data)),
    fetchLectures: data => dispatch(actionClassCreator.fetchLectures(data)),
    fetchLecture: data => dispatch(actionLectureCreator.fetchLecture(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LandingLayout04));
